module.exports = __webpack_public_path__ + "img/shop_C_3.02d12c77.png";